import Contest from './contest';
export default Contest;
